import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as dialogPopupActions from '../../actions/dialogPopupActions';
import * as keyboardConstants from '../../constants/keyboardConstants';
import * as dataHelper from '../../helpers/dataHelper';
import * as appHelper from '../../helpers/appHelper';
export class ContentDialog extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            dialogPopup: this.props.dialogPopup,
            tabbableElements:[],
            isDialog: true,
            isOpen: false,
            elementInterval:{},
            guid: dataHelper.createGuid(),
            fontSize: this.props.fontSize,
            height: undefined,
            updateHeight: true,

        };
        this.setTabbableElements =  this.setTabbableElements.bind(this);
        this.setKeyboardAccessibility = this.setKeyboardAccessibility.bind(this);
        this.setInitialFocus = this.setInitialFocus.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);
        this.setElementInterval = this.setElementInterval.bind(this);
        this.setHeight = this.setHeight.bind(this);
        this.getHeight = this.getHeight.bind(this);
    }

    componentDidMount(){
        this.setTabbableElements();
        window.addEventListener("keydown", this.onKeyDown);
        window.addEventListener("keyup", this.onKeyUp);
        this.setElementInterval();
    }

    componentWillReceiveProps(nextProps) {
        if(this.state.dialogPopup !== nextProps.dialogPopup){
            this.setState({dialogPopup: Object.assign({},nextProps.dialogPopup)});
        }

        if (this.state.fontSize !== nextProps.fontSize) {
            this.setState({fontSize: nextProps.fontSize, updateHeight: true});
        }
    }

    componentDidUpdate(){
        if(!this.state.isOpen && this.state.dialogPopup.isOpen){
            this.setInitialFocus();
        }

        if(this.state.updateHeight){
            this.setHeight();
        }
    }

    componentWillUnmount() {
        window.removeEventListener("keydown", this.onKeyDown);
        window.removeEventListener("keyup", this.onKeyUp);
        clearInterval(this.state.elementInterval);
    }

    setElementInterval(){
        let interval = setInterval(this.setTabbableElements, 2000);
        this.setState({elementInterval: interval});
    }

    setTabbableElements(){
        let dialog = this.refs.contentDialog;
        this.setState({tabbableElements: Object.assign([],dataHelper.getAllTabbableElements(dialog))});
    }

    setKeyboardAccessibility(event){
        if(event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY){
            event.preventDefault();
            this.props.onCloseDialog();
        }
    }

    setInitialFocus() {
        this.setState({isOpen: true});
        let closePanel = this.refs['closeDialogBtn'];
        let func =  this.openDialog;
        if(appHelper.isDefined(closePanel)) {
            setTimeout(function () {
                closePanel.focus();
            }, 1000);
        }

    }

    onKeyDown(event) {
        let shiftPressed = this.state.shiftPressed;
        let tabPressed = this.state.tabPressed;

        if (event.which === keyboardConstants.ESCAPE_KEY) {
            event.preventDefault();
            this.props.onCloseDialog();
        }

        if (event.which === keyboardConstants.TAB_KEY) {
            tabPressed = true;
            this.setState({
                tabPressed: tabPressed
            });
        }

        if (event.which === keyboardConstants.SHIFT_KEY) {
            this.setState({
                shiftPressed: shiftPressed
            });
        }
    }

    onKeyUp(event) {
        let activeItem = document.activeElement;
        let activeItemId = activeItem.id;
        //console.log(activeItemId);
        if(activeItemId === this.state.tabbableElements[0].id){
            //go to last
            //console.log(this.state.tabbableElements[this.state.tabbableElements.length - 2]);
            this.state.tabbableElements[this.state.tabbableElements.length - 2].focus();
        }else if(activeItemId ===  this.state.tabbableElements[this.state.tabbableElements.length - 1].id){
            this.state.tabbableElements[1].focus();
        }

        this.setState({
            tabPressed: false,
            shiftPressed: false
        });
    }

    setHeight(){

        this.setState({updateHeight: false});
        let screenWrapper = document.getElementById('screenWrapper');
        let header = document.getElementById(`dialogHeader_${this.state.guid}`);

        if(appHelper.isDefined(header) && header !== null){
            let newHeight = (screenWrapper.offsetHeight - header.offsetHeight);
            this.setState({height: newHeight});
        }
    }

    getHeight(){
        if(appHelper.isDefined(this.state.height)){
            return {
                height: `${this.state.height}px`,
                minHeight: `${this.state.height}px`,
            };
        }else{
            return {};
        }
    }

    render() {
        return (
            <div className={this.state.dialogPopup.className + " " + this.state.dialogPopup.config.theme} ref={`contentDialog`} id="content-dialog" role="dialog"  aria-modal={this.state.isDialog} aria-labelledby="content-dialog">
                {this.state.isOpen
                    ?
                    <div>
                        <div id={`firstTabIndex_contentDialog_${this.state.guid}`} tabIndex="0" role="button"/>
                        <div className="dialog-header truncate-text-container guroo-dialog-header"
                             id={`dialogHeader_${this.state.guid}`}>
                            <div className={`${this.state.dialogPopup.config.icon} icon-first dialog-title`} role="link"
                                 tabIndex="0" ref="closeDialogBtn" id="closeDialogBtn"
                                 onClick={this.props.onCloseDialog}
                                 onKeyDown={this.setKeyboardAccessibility}>{this.state.dialogPopup.config.title}</div>
                        </div>
                        <div className="dialog-body" style={this.getHeight()}>

                            {this.state.dialogPopup.config.childComponents.map(component =>
                            <div key={"container_" + component.id} className="component-seperator">
                                {component.componentProps !== null
                                    ? <component.childComponent key={component.id} {...component.componentProps}/>
                                    : <component.childComponent key={component.id}/>
                                }
                            </div>
                            )}


                        </div>
                        <div id={`lastTabIndex_contentDialog_${this.state.guid}`} tabIndex="0" role="button"/>
                    </div>
                :null
            }
            </div>
        );
    }
}

ContentDialog.propTypes = {
    dialogPopup: PropTypes.object.isRequired,
    onCloseDialog: PropTypes.func.isRequired,
    actions: PropTypes.object.isRequired,
    fontSize: PropTypes.object.isRequired,
};

//Pull in the React Router context so router is available on this.context.router.
ContentDialog.contextTypes = {
    router: PropTypes.object
};

//Init
function mapStateToProps(state, ownProps) {
    return {
        fontSize: state.fontSize
    };
}

function mapDispatchToProps(dispatch) {
    return {

        actions: bindActionCreators(Object.assign({}, dialogPopupActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ContentDialog);

/*
ContentDialog.propTypes ={
    dialogPopup: React.PropTypes.object.isRequired,
    onCloseDialog: React.PropTypes.func.isRequired,
};

export default ContentDialog;*/



/** WEBPACK FOOTER **
 ** ./src/components/dialogs/ContentDialog.js
 **/